import { render, staticRenderFns } from "./Deprecation.vue?vue&type=template&id=5f7e8f59"
import script from "./Deprecation.vue?vue&type=script&lang=js"
export * from "./Deprecation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports